// Column Types
export const NOTE = 'note';
export const OWNER_NAME = 'owner_name';
export const OPPORTUNITY_NAME = 'opportunity_name';
export const OPPORTUNITY_STAGE = 'opportunity_stage';
export const OPPORTUNITY_AMOUNT = 'opportunity_amount';
export const NAME = 'name';
export const PARTNERSTACK = 'partnerstack';
export const CUSTOM_TEXT = 'custom_text';

export const PRIVATE_COLUMNS = [
  OPPORTUNITY_NAME,
  OPPORTUNITY_STAGE,
  OPPORTUNITY_AMOUNT,
  PARTNERSTACK,
];

export const GOOGLE_SHEETS = 'google_sheets';
export const FILE_UPLOAD = 'file_upload';

// Access Types
export const OWNER = 'owner';
export const SHARED = 'shared';
export const EDITOR = 'editor';
export const CREATOR = 'creator';

// List Access Status Codes
export const DISABLED_LISTS = 'DISABLED_LISTS';
export const FULL_ACCESS = 'FULL_ACCESS';
export const LIMITED_ACCESS = 'LIMITED_ACCESS';
export const NO_ACCESS = 'NO_ACCESS';

// List Notifications
export const LIST_SHARING_UPDATED = 'list_sharing_updated';
export const LIST_MEMBERS_UPDATED = 'list_members_updated';
export const LIST_NOTE_UPDATED = 'list_note_updated';
export const MAX_RECORDS_SHOWN = 5;

//
export const MAX_NUM_NOTE_CHARS = 1000;
export const MAX_NUM_CUSTOM_NOTE_CHARS = 500;
